import { render } from "./ManageFreeInventory.vue?vue&type=template&id=6dbfdf24&scoped=true"
import script from "./ManageFreeInventory.vue?vue&type=script&lang=js"
export * from "./ManageFreeInventory.vue?vue&type=script&lang=js"

import "./ManageFreeInventory.vue?vue&type=style&index=0&id=6dbfdf24&scoped=true&lang=css"
import "./ManageFreeInventory.vue?vue&type=style&index=1&id=6dbfdf24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbfdf24"]])

export default __exports__